import MapboxDraw from '@mapbox/mapbox-gl-draw'
import { isActiveFeature, isInactiveFeature, isVertex, noTarget } from '@mapbox/mapbox-gl-draw/src/lib/common_selectors'
import cloneDeep from 'lodash.clonedeep'

import DirectSelectRouteModeCommon from './DirectSelectRouteModeCommon'

const DirectSelectTransferRouteMode = cloneDeep(MapboxDraw.modes.direct_select)

DirectSelectTransferRouteMode.clickInactive = function () {}

DirectSelectTransferRouteMode.clickNoTarget = function () {}

DirectSelectTransferRouteMode.dragFeature = function () {}

DirectSelectTransferRouteMode.onVertex = DirectSelectRouteModeCommon.onVertex

DirectSelectTransferRouteMode.onClick = DirectSelectRouteModeCommon.onClick

export default DirectSelectTransferRouteMode
